var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9999 7.20001V5.60001C3.9999 4.53914 4.42133 3.52172 5.17148 2.77158C5.92162 2.02143 6.93904 1.60001 7.9999 1.60001C9.06077 1.60001 10.0782 2.02143 10.8283 2.77158C11.5785 3.52172 11.9999 4.53914 11.9999 5.60001V7.20001C12.4242 7.20001 12.8312 7.36858 13.1313 7.66864C13.4313 7.96869 13.5999 8.37566 13.5999 8.80001V12.8C13.5999 13.2244 13.4313 13.6313 13.1313 13.9314C12.8312 14.2314 12.4242 14.4 11.9999 14.4H3.9999C3.57556 14.4 3.16859 14.2314 2.86853 13.9314C2.56847 13.6313 2.3999 13.2244 2.3999 12.8V8.80001C2.3999 8.37566 2.56847 7.96869 2.86853 7.66864C3.16859 7.36858 3.57556 7.20001 3.9999 7.20001ZM10.3999 5.60001V7.20001H5.5999V5.60001C5.5999 4.96349 5.85276 4.35304 6.30285 3.90295C6.75293 3.45286 7.36338 3.20001 7.9999 3.20001C8.63642 3.20001 9.24687 3.45286 9.69696 3.90295C10.147 4.35304 10.3999 4.96349 10.3999 5.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/LockClosed.88c7a2bfaa0a5b3cc9d635cdcb26bddd.svg";
export { ForwardRef as ReactComponent };